import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Add from "@material-ui/icons/AddBox";
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input:{
  marginTop:"0 !important"
  },
    nb:{
      color:"red",
        fontSize:"12px"
    },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width:"80%"
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width:"100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {        marginTop: "0px",        width: '100%'    }
});


const SettingsPanel = ({
                           classes,
                           handleSearch,
                           handleChange,
                           NotificationTypeId,
                           notificationType,
                           airlinesData,
                           fullScreen,
                           handleAdd,
                           isOpen,
                           handleSubmit,
                           airline,
                           notificationErrorComponent,
                           emailErrorComponent,
                           airlineErrorComponent,
                           airportErrorComponent,
                           numberErrorComponent,
                           airlineId,
                           handleClose,
                            airportCode,
                           airportCode2,
                           handleSelect,
                            airports,
                            user,
                           disabled
}) => {
    return (
        <div className={classes.root}>
          <Grid container spacing={24}>
            <Grid item md={3} xs={12}>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="airline">Select Airline</InputLabel>
                    <AutocompleteSelect
                        options={airlinesData.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                        handleSelectChange={(e, name) => handleChange(e, name)}
                        name={"airline"}
                        selectedOption={airline}
                    />
                    {/*
                    <Select
                        value={airline}
                        onChange={handleChange}
                        inputProps={{
                            name: 'airline',
                            id: 'airline',
                        }}
                    >
                        <MenuItem value="-1">All Airlines</MenuItem>
                        {airlinesData.map((option, i) => (
                            <MenuItem
                                key={i}
                                value={option.AirlineId}
                                className={classes.select}
                            >
                                {option.Airline}
                            </MenuItem>
                        ))}
                    </Select>
                    */}
                </FormControl>
            </Grid>
              <Grid item md={3} sm={12}>
                  <FormControl className={classes.formControl}>
                      <InputLabel shrink htmlFor="age-simple">Airports</InputLabel>
                      <AutocompleteSelect
                          options={airports.map(option => ({value: option.Code, label: option.Name}))}
                          name={"airportCode"}
                          selectedOption={airportCode}
                          handleSelectChange={(e, name) => handleChange(e, name)}
                          disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                      />
                      {/*
                      <Select
                          value={airportCode}
                          disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                          onChange={(event)=>handleSelect(event)}
                          formcontrolprops={{
                              fullWidth: true
                          }}
                          inputProps={{
                              name: 'airportCode',
                              id: 'airportCode',
                          }}
                      >
                          <MenuItem value="-1">All Airports</MenuItem>
                          {airports.map((option, i) => (
                              <MenuItem
                                  key={i}
                                  value={option.Code}
                                  className={classes.select}
                              >
                                  {option.Name}
                              </MenuItem>
                          ))}
                      </Select>
                      */}
                  </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                  <Button
                      className={classes.searchButton}
                      onClick = {()=>handleSearch()}
                  >
                      Search
                  </Button>
              </Grid>
            <Grid item md={3} xs={12}>
              <Button
                  color="primary"
                  className={classes.searchButton}
                  onClick = {handleAdd}
                  autoFocus
              >
               <Add/> Add Notification
              </Button>
            </Grid>
          </Grid>
            <Dialog
                fullScreen={fullScreen}
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" style={{backgroundColor:"#66bb6a"}}>
                    <span style={{color:"white",textTransform:"uppercase"}}> Add Notification</span>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item md={10} xs={12}>
                            <FormControl className={classes.formControl}>
                                <InputLabel shrink htmlFor="NotificationTypeId">Notification Type</InputLabel>
                                <AutocompleteSelect
                                    options={notificationType.map(option => ({ value: option.value, label: option.type }))}
                                    selectedOption={NotificationTypeId}
                                    handleSelectChange={(e, name) => handleChange(e, name)}
                                    // selectLabel={"Airlines"}
                                    name={"NotificationTypeId"}
                                />
                                {/*<Select*/}
                                    {/*value={NotificationTypeId}*/}
                                    {/*onChange={(event)=>handleSelect(event)}*/}
                                    {/*inputProps={{*/}
                                        {/*name: 'NotificationTypeId',*/}
                                        {/*id: 'NotificationTypeId',*/}
                                    {/*}}*/}
                                {/*>*/}
                                    {/*<MenuItem value="-1">Select Notification Type</MenuItem>*/}
                                    {/*{notificationType.map((option, i) => (*/}
                                        {/*<MenuItem*/}
                                            {/*key={i}*/}
                                            {/*name="NotificationTypeId"*/}
                                            {/*value={option.value}*/}
                                            {/*className={classes.select}*/}
                                        {/*>*/}
                                            {/*{option.type}*/}
                                        {/*</MenuItem>*/}
                                    {/*))}*/}
                                {/*</Select>*/}
                            </FormControl>
                            {notificationErrorComponent && <div style={{color:'red',fontSize:"13px"}}>Select Notification Type</div>}

                        </Grid>
                    <Grid item md={10} xs={12}>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="airline">Select Airline</InputLabel>
                            <AutocompleteSelect
                                options={airlinesData.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                                handleSelectChange={(e, name) => handleChange(e, name)}
                                name={"airlineId"}
                                selectedOption={airlineId}
                                disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            />
                           {/*<Select*/}
                                {/*value={airlineId}*/}
                                {/*disabled={user.AppRole === appConstants.ROLES.AIRLINE}*/}
                                {/*onChange={(event)=>handleSelect(event)}*/}
                                {/*inputProps={{*/}
                                    {/*name: 'airlineId',*/}
                                    {/*id: 'airline',*/}
                                {/*}}*/}
                            {/*>*/}
                                {/*/!*<MenuItem value="-1">Select Airline</MenuItem>*!/*/}
                                {/*{airlinesData.map((option, i) => (*/}
                                    {/*<MenuItem*/}
                                        {/*key={i}*/}
                                        {/*value={option.AirlineId}*/}
                                        {/*className={classes.select}*/}
                                    {/*>*/}
                                        {/*{option.Airline}*/}
                                    {/*</MenuItem>*/}
                                {/*))}*/}
                            {/*</Select>*/}
                        </FormControl>
                        {airlineErrorComponent && <div style={{color:'red',fontSize:"13px"}}>Select Airline</div>}

                    </Grid>

                        <Grid item md={10} xs={12}>

                            <FormControl className={classes.formControl}>
                                <InputLabel shrink htmlFor="airline">Select Airport</InputLabel>
                                <AutocompleteSelect
                                    options={airports.map(option => ({value: option.Code, label: option.Name}))}
                                    name={"airportCode2"}
                                    selectedOption={airportCode2}
                                    handleSelectChange={(e, name) => handleChange(e, name)}
                                    disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                                />
                            </FormControl>
                                {/*
                                <Select
                                    disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                                    value={airportCode2}
                                    onChange={handleChange}
                                    inputProps={{
                                        name: 'airportCode2',
                                        id: 'airport2',
                                    }}
                                >
                                    <MenuItem value="-1">Select Airport</MenuItem>
                                    {airports.map((airport, i) => (
                                        <MenuItem
                                            key={i}
                                            value={airport.Code}
                                            className={classes.select}
                                        >
                                            {airport.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                */}
                                {airportErrorComponent && <div style={{color:'red',fontSize:"13px"}}>Select Airport</div>}
                        </Grid>

                    <Grid item md={12} xs={12}>
                        <TextField
                            multiline
                            rowsMax="10"
                            id="email"
                            label="Email"
                            name="addEmails"
                            className={classes.textField}
                            onChange={(event)=>handleSelect(event)}
                            margin="normal"
                            variant="outlined"
                        />
                        <div className={classes.nb}>*separate multiple emails with comma</div>
                        {emailErrorComponent && <div style={{color:'red',fontSize:"13px"}}>Email is required</div>}
                    </Grid>

                    <Grid item md={12} xs={12}>
                        <TextField
                            multiline
                            rowsMax="10"
                            id="mobileNo"
                            label="Mobile Number"
                            name="mobileNumbers"
                            className={classes.textField}
                            onChange={(event)=>handleSelect(event)}
                            margin="normal"
                            variant="outlined"
                        />
                        <div className={classes.nb}>*separate multiple numbers with comma</div>
                        {numberErrorComponent && <div style={{color:'red',fontSize:"13px"}}>Mobile Number is required</div>}
                    </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="danger">
                        Cancel
                    </Button>
                    <Button disabled={disabled} onClick={handleSubmit} color="primary" autoFocus>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/views/EmailSettings/settingsPanel.js